import { SVGProps } from "react";
const CheckSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
    viewBox="0 0 16 16"
    height={16}
    width={16}
  >
    <path
      fill={props.color ? props.color : "#7D8690"}
      d="M4.192 9.558a.625.625 0 0 0-.884.884l4.375 4.375c.244.244.64.244.884 0l8.75-8.75a.625.625 0 1 0-.884-.884l-8.308 8.308-3.933-3.933Z"
    />
  </svg>
);
export default CheckSvg;
